<template>
  <div class="gmap-search">
    <ui-dropdown
      ref="searchInput"
      v-model="searchValue"
      :options="locations"
      :placeholder="$t('search.label')"
      label="name"
      track-by="internal_id"
      @close="toggle"
      @input="updateRoute"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UiDropdown from '@/components/UI/Dropdown.vue'
import { isMobile } from '@/utils/navigator.util'

export default {
  name: 'GmapSearch',
  components: {
    UiDropdown,
  },
  props: {
    locations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchValue: '',
      isMobile: isMobile(),
    }
  },
  computed: {
    ...mapGetters({
      isZonesIntentionView: 'radar/isZonesIntentionView',
    }),
  },
  methods: {
    ...mapActions({
      toggleSearch: 'radar/toggleSearch',
    }),
    toggle() {
      if (!this.isMobile) {
        this.toggleSearch(false)
      }
    },
    updateRoute(location) {
      if (this.isZonesIntentionView) {
        this.$router.push({
          name: 'divisionZonesIntention',
          params: { level: 1, key: location.internal_id },
          query: { level: 2 },
        })
      } else {
        this.$router.push({
          name: 'location',
          params: { ...this.$route.params, location: location.internal_id },
          query: this.$route.query,
        })
      }
      this.searchValue = ''
    },
  },
}
</script>
